import { HabitSchedule, Timestamp } from '@griply/types';
import { isBefore, startOfDay } from 'date-fns';

import { getActualScheduleStartDate } from './schedules';

export const getActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
) => {
  if (!schedules?.length) {
    return undefined;
  }

  const todayStart = startOfDay(today);

  // Single schedule is always active, unless it has expired
  if (schedules.length === 1) {
    const schedule = schedules[0];
    return schedule.endDate && !isBefore(schedule.endDate, todayStart)
      ? undefined
      : schedule;
  }

  // Filter out schedules with a passed endDate
  const nonExpired = schedules.filter(
    (schedule) => !schedule.endDate || !isBefore(schedule.endDate, todayStart),
  );

  if (!nonExpired.length) {
    return undefined;
  }

  // Prefer the most recently started schedule
  const started = nonExpired
    .filter(
      (schedule) => !isBefore(todayStart, getActualScheduleStartDate(schedule)),
    )
    .sort(
      (scheduleA, scheduleB) =>
        scheduleB.startDate.getTime() - scheduleA.startDate.getTime(),
    );

  if (started.length) {
    return started[0];
  }

  // No started schedule, fall back to the nearest upcoming one
  return nonExpired.sort(
    (scheduleA, scheduleB) =>
      scheduleA.startDate.getTime() - scheduleB.startDate.getTime(),
  )[0];
};
